export const ChartFilterConstants = {
  GET_PREFERRED_CHART_FILTERS_REQUEST: 'DEEPDIVE/GET_PREFERRED_CHART_FILTERS_REQUEST',
  GET_PREFERRED_CHART_FILTERS_SUCCESS: 'DEEPDIVE/GET_PREFERRED_CHART_FILTERS_SUCCESS',
  GET_PREFERRED_CHART_FILTERS_FAILED: 'DEEPDIVE/GET_PREFERRED_CHART_FILTERS_FAILED',

  GET_FILTER_UPDATED_CHART_ID: 'DEEPDIVE/GET_FILTER_UPDATED_CHART_ID'
};
